export const FETCH_ESTABLISHMENTS_REQUEST = 'FETCH_ESTABLISHMENTS_REQUEST'
export const FETCH_ESTABLISHMENTS_FULFILLED = 'FETCH_ESTABLISHMENTS_FULFILLED'
export const FETCH_ESTABLISHMENTS_ERRED = 'FETCH_ESTABLISHMENTS_ERRED'
export const SET_SELECTED_ESTABLISHMENT = 'SET_SELECTED_ESTABLISHMENT'
